import axios, { AxiosInstance } from 'axios'
import useLoaderStore from '../stores/loader'
import pinia from '../stores/store'
import { useAuthStore } from '../stores/auth'

const config = {
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-type': 'application/json',
  },
}
const storeLoader = useLoaderStore(pinia)

const apiClient: AxiosInstance = axios.create(config)
// add request interceptors
apiClient.interceptors.request.use(
  function (config) {
    let token = localStorage.getItem('token')
    if (token != null && config && config.headers) {
      config.headers['Authorization'] = 'bearer ' + token
    }
    storeLoader.pending()
    return config
  },
  function (error) {
    storeLoader.done()
    return Promise.reject(error) //
  },
)

// Add a response interceptor
apiClient.interceptors.response.use(
  function (response) {
    storeLoader.done()
    return response
  },
  function (error) {
    if (error.response.status === 401 && error.response.config && !error.response.config.__isRetryRequest) {
      console.log(401)
      const storeAuth = useAuthStore()
      if(storeAuth.isAuthenticated)storeAuth.logout()
      storeLoader.done()
      return
    }
    if (error.response.status === 403) {
      console.warn('using request: ' + error.request.responseURL + ' retrieve: ' + error.response.data.errorText)
      storeLoader.done()
      return
    }
    let message = error.response.data ? error.response.data.errorText : ''
    if (message && message > '') {
      const _startof = message.indexOf('{')
      const _endof = message.indexOf('}')
      if (_startof > 0 && _endof > 0 && _startof < _endof) {
        message = message.substring(_startof + 1, _endof)
      }
    } else {
      message = error
    }
    storeLoader.done()
    return Promise.reject(message)
  },
)

export default apiClient
